import * as S from './PBHomepageBanner.styles'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import BrowserThemeColor from 'components/ThemeColor/BrowserThemeColor'
import { analytics, EVENT_NAMES } from '../../../services/Analytics/Analytics'
import { generateProductCountEventProperties } from '../../../services/Analytics/productsAnalytics'
import { usePhotoBookInProgress } from '../../../hooks/useWorkInProgress'
import { PHOTO_BOOK_HOMEPAGE_URL, PHOTO_BOOK_URL } from '../../../config/config'

const IMAGE_URL =
  'https://res.cloudinary.com/mixtiles/image/upload/assets/photoBooks/home-banner.png'

export default function PBHomepageBanner() {
  const theme = useTheme()
  const { t } = useTranslation()
  const hasPhotoBookInProgress = usePhotoBookInProgress()

  const photoBookUrl = hasPhotoBookInProgress
    ? PHOTO_BOOK_URL
    : PHOTO_BOOK_HOMEPAGE_URL

  const handleClick = () => {
    analytics.track(
      EVENT_NAMES.HOME_PAGE_BOOKS_BANNER_TAPPED,
      generateProductCountEventProperties()
    )
  }

  return (
    <S.Container>
      <BrowserThemeColor color={theme.colors.grayAccent} />
      <S.Image src={IMAGE_URL} />
      <S.TextContainer>
        <S.Title>{t('product_selection.photo_books_name')}</S.Title>
        <S.Subtitle>{t('homepage.photo_books_banner.subtitle')}</S.Subtitle>
      </S.TextContainer>
      <S.TryNow
        to={{ pathname: photoBookUrl }}
        state={{ source: 'Homepage Banner' }}
        onClick={handleClick}
      >
        {t('homepage.photo_books_banner.cta')}
      </S.TryNow>
    </S.Container>
  )
}
